<script>
  export default {
    name:"PackProductButton",
    props:["recipeType", "productId"]
  }
</script>

<template>
  <b-button variant="primary" class="pointer" v-b-tooltip.hover title="Zapakuj"
            :href="'#/Pakowanie/Zapakuj/' + recipeType + '/' + productId">
    <i class="fas fa-box"></i>
  </b-button>
</template>
